module.exports = __webpack_public_path__ + "static/media/card-email-br.f0dc076f.png";